import Generic from './Generic.svg';
import Insurance from './Insurance.svg';
import Ecommerce from './Ecommerce.svg';
import Integrations from './Integrations.svg';
import Telecom from './Telecom.svg';
import CustomerSupport from './CustomerSupport.svg';
import Banking from './Banking.svg';
import MediaAndEntertainment from './MediaAndEntertainment.svg';
import Globe from './Globe.svg';
import Mortgage from './Mortgage.svg';
import Node from './Node.svg';

import Feedback from './Feedback.svg';
import NodeIndicator from './NodeIndicator.svg';

const CategoryIcons = {
  generic: Generic,
  insurance: Insurance,
  ecommerce: Ecommerce,
  integrations: Integrations,
  telecom: Telecom,
  'customer support': CustomerSupport,
  'banking sector': Banking,
  node: Node,
  nodeIndicator: NodeIndicator,
  globe: Globe,
  mortgage: Mortgage,
  feedback: Feedback,
  'media & entertainment': MediaAndEntertainment,
};

export default CategoryIcons;
